<template>
    <v-dialog v-model="modal" max-width="1000px">
        <v-card>
            <v-card-title>{{ $t('View log item') }}</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <fieldset>
                    <legend>{{ $t('Information') }}</legend>
                    <v-row>
                        <v-col cols="2">
                            <div class="subheader">Id</div>
                        </v-col>
                        <v-col cols="10">
                            <div class="body-3">{{ data.id }}</div>
                        </v-col>
                        <v-col cols="2">
                            <div class="subheader">{{ $t('Category') }}</div>
                        </v-col>
                        <v-col cols="10">
                            <div style="text-transform: capitalize" class="body-3">{{ data.category }}</div>
                        </v-col>
                        <v-col cols="2">
                            <div class="subheader">{{ $t('Type') }}</div>
                        </v-col>
                        <v-col cols="10">
                            <div style="text-transform: capitalize" class="body-3">{{ data.type }}</div>
                        </v-col>
                        <v-col cols="2">
                            <div class="subheader">{{ $t('Date') }}</div>
                        </v-col>
                        <v-col cols="10" v-if="typeof data.date.date !== 'undefined'">
                            <div class="body-3">{{ data.date.date | moment(datetimeformat) }}</div>
                        </v-col>
                        <v-col cols="2">
                            <div class="subheader">{{ $t('Description') }}</div>
                        </v-col>
                        <v-col cols="10">
                            <div class="body-3">{{ data.description }}</div>
                        </v-col>
                    </v-row>
                </fieldset>
                <br>
                <fieldset v-if="typeof data.person !== 'undefined'">
                    <legend>{{ $t('User') }}</legend>
                    <v-row>
                        <v-col cols="2">
                            <div class="subheader">{{ $t('Person') }}</div>
                        </v-col>
                        <v-col cols="10">
                            <div class="body-3">{{ data.person.fullName }}</div>
                        </v-col>
                        <v-col cols="2">
                            <div class="subheader">{{ $t('Username') }}</div>
                        </v-col>
                        <v-col cols="10">
                            <router-link style="cursor: pointer; text-decoration: underline" class="body-3" :to="{name: 'user_update_general', params: { id: data.person.id }}">{{ data.person.user.userName }} <v-icon>fas fa-eye</v-icon></router-link>
                        </v-col>
                        <v-col cols="2">
                            <div class="subheader">{{ $t('User type') }}</div>
                        </v-col>
                        <v-col cols="10">
                            <div class="body-3">{{ data.person.user.type }}</div>
                        </v-col>
                    </v-row>
                    <v-row v-if="data.ipAddress">
                        <v-col cols="2">
                            <div class="subheader">{{ $t('IP address') }}</div>
                        </v-col>
                        <v-col cols="10">
                            <div class="body-3">{{ data.ipAddress }}
                                <a :href="'https://ipinfo.io/' + data.ipAddress" target="_blank" class="btn btn--flat btn--small primary--text"><div class="btn__content"><i aria-hidden="true" class="icon material-icons">search</i> {{ $t('View IP information') }}</div></a>
                            </div>
                        </v-col>
                    </v-row>
                </fieldset>
                <br>
                <fieldset v-if="data.type !== 'login' && data.type !== 'email'">
                    <legend>{{ data.type === 'create' ? $t('Created') : data.type === 'update' ? $t('Updated') : data.type === 'delete' ? $t('Removed') : '' }} Entity</legend>
                    <v-row>
                        <v-col cols="2">
                            <div class="subheader">Entity</div>
                        </v-col>
                        <v-col cols="10">
                            <div class="body-3">{{ data.extraRow.entity }}</div>
                        </v-col>
                    </v-row>
                    <template v-if="data.type === 'delete'">
                        <v-row>
                            <v-col cols="2">
                                <div class="subheader">Id</div>
                            </v-col>
                            <v-col cols="10">
                                <div class="body-3">{{ data.extraRow.originalData.id }}</div>
                            </v-col>
                        </v-row>
                    </template>
                    <template v-else>
                        <v-row>
                            <v-col cols="2">
                                <div class="subheader">Id</div>
                            </v-col>
                            <v-col cols="10">
                                <div class="body-3">{{ data.extraRow.id }}</div>
                            </v-col>
                        </v-row>
                    </template>
                    <br>
                </fieldset>
                <fieldset v-if="data.extraRow.changes">
                    <legend>{{ $t('Changed fields') }}</legend>
                    <template v-for="(item, index) in data.extraRow.changes">
                        <v-row>
                            <v-col cols="2">
                                <div class="subheader">{{ index }}</div>
                            </v-col>
                            <v-col xs4>
                                <code>{{ item[0] instanceof String ? item[0] : item[0] instanceof Object && item[0].date ? item[0].date : item[0] }}</code>
                            </v-col>
                            <v-col cols="2">
                                <v-icon>far fa-arrow-right</v-icon>
                            </v-col>
                            <v-col xs4>
                                <code>{{ item[1] instanceof String ? item[1] : item[1] instanceof Object && item[1].date ? item[1].date : item[1] }}</code>
                            </v-col>
                        </v-row>
                    </template>
                </fieldset>
                <fieldset v-if="data.extraRow.created">
                    <legend>{{ $t('Created fields') }}</legend>
                    <template v-for="(item, index) in data.extraRow.created">
                        <v-row class="mb-1">
                            <v-col cols="2">
                                <div class="subheader">{{ index }}</div>
                            </v-col>
                            <v-col cols="10">
                                <code>{{ item }}</code>
                            </v-col>
                        </v-row>
                    </template>
                </fieldset>
                <fieldset v-if="data.type === 'delete'">
                    <legend>{{ $t('Original data') }}</legend>
                    <template v-for="(item, index) in data.extraRow.originalData">
                        <v-row class="mb-1">
                            <v-col cols="2">
                                <div class="subheader">{{ index }}</div>
                            </v-col>
                            <v-col cols="10">
                                <code>{{ item }}</code>
                            </v-col>
                        </v-row>
                    </template>
                </fieldset>
                <fieldset v-if="data.type === 'email'">
                    <legend>{{ $t('E-mail') }}</legend>
                    <v-row>
                        <v-col cols="2">
                            <div class="subheader">{{ $t('Error message') }}</div>
                        </v-col>
                        <v-col cols="10">
                            <strong>{{ data.extraRow.error }}</strong>
                        </v-col>
                        <v-col cols="2">
                            <div class="subheader">{{ $t('Recipients') }}</div>
                        </v-col>
                        <v-col cols="10">
                            <ul style="margin-left: 15px;">
                                <template v-for="item in data.extraRow.recipients">
                                    <li>{{ item }}</li>
                                </template>
                            </ul>
                        </v-col>
                        <v-col cols="2">
                            <div class="subheader">{{ $t('Subject') }}</div>
                        </v-col>
                        <v-col cols="10">
                            {{ data.extraRow.subject }}
                        </v-col>
                        <v-col xs12>
                            <div class="subheader">{{ $t('Content') }}</div>
                        </v-col>
                    </v-row>
                    <v-col xs12>
                        <div v-html="data.extraRow.body"></div>
                    </v-col>
                </fieldset>
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-spacer />
                <v-btn color="primary" small style="min-width: 100px" @click="modal = false">{{ $t('Close') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script lang="ts" type="typescript">
    import { Component, Prop, Vue } from 'vue-property-decorator';
    import { Request } from '@/lib/apollo';
    import Config from '@/config';

    @Component
    export default class LogDetailsDialog extends Vue {
        @Prop()
        id: string;

        data: any = {
            date: {},
            person: {
                id: '0',
                user: '',
            },
            extraRow: '',
        };
        datetimeformat = Config.datetimeformat;

        modal: boolean = false;

        created() {
            this.$root.$off('log-details-dialog-enable');
            this.$root.$on('log-details-dialog-enable', (data) => {
                this.openDialog(data.id);
            });
        }

        openDialog(id) {
            Request.make('/log/info/' + id, Request.GET).then((res) => {
                this.data = res;
                this.modal = true;
            });
        }
    }
</script>